import ContractDocument from "../ContractDocument";

export default class Shareable extends ContractDocument {
  static type = "contractDocumentShareables";
}
